
export function titleCase(str) {
  if(typeof str==='string'){
    return str.toLowerCase().split(' ').map(function(word) {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  }
  else return str; 
}
